const validatePhoneNumber = (number) => {
  const phoneNumPattern = new RegExp(
    /^(?:(?:\+|0{0,2})91(\s*|[\-])?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/
  );

  return phoneNumPattern.test(number);
};
// const validateEmail = (email) => {
//   const emailPattern = new RegExp(
//     /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
//   );
//   return emailPattern.test(email);
// };
const validateNameWithOnlyLetters = (data) => {
  if (typeof data !== "string") return false;

  const pattern = /^[a-zA-Z]+$/; // only letters, no numbers or special characters
  return pattern.test(data.trim());
};

const validateEmail = (email) => {
  // const emailPattern = new RegExp(/^[a-z0-9.]+@[^\s@]+\.[^\s@]+$/);
  // return emailPattern.test(email);

  if (email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email.trim());
  }
};

const validateTextInput = (data) => {
  return data !== undefined && data !== null && data?.trim() !== "";
};
const validateNameInput = (data) => {
  if (typeof data !== "string") return false;

  const pattern = /^[a-zA-Z0-9]+$/; // only letters and numbers, no spaces or special chars
  return pattern.test(data.trim());
};
const validateNumberInput = (data) => {
  return !isNaN(data) && Number(data) >= 0;
};
const validatePassword = (data, length = 6) => {
  return data?.trim() !== "" && data?.trim().length >= length;
};
function validateLink(url) {
  const regex = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  return regex.test(url);
}
const emptyObj = (obj) => {
  return Object.keys(obj).length === 0;
};

function validateGSTIN(gstin) {
  const gstinPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[1-9]{1}$/;

  // Check if the GSTIN matches the pattern
  if (gstin && gstin.match(gstinPattern)) {
    return true; // Valid GSTIN
  } else {
    return false; // Invalid GSTIN
  }
}

export {
  validatePhoneNumber,
  validateEmail,
  validateTextInput,
  validateNameInput,
  validatePassword,
  emptyObj,
  validateNumberInput,
  validateLink,
  validateGSTIN,
  validateNameWithOnlyLetters,
};
